import { LenderName } from '@nemuru-eng/js-api-client';
export const SPANISH_BANKS_LIST = [
  {
    EUROPEAN_CODE: 'ES0241',
    NAME: 'A&G BANCO, S.A.',
    ADDRESS: 'Paseo de la Castellana, 92, 28046, Madrid',
    SUPERVISOR_CODE: '0241',
    LENDER_NAME: null,
    LOGO: null,
  },
  {
    EUROPEAN_CODE: 'ES2080',
    NAME: 'Abanca Corporacion Bancaria, S.A.',
    ADDRESS: 'CI Cantón Claudino Pita, 2, 15300, Betanzos',
    SUPERVISOR_CODE: '2080',
    LENDER_NAME: null,
    LOGO: null,
  },
  {
    EUROPEAN_CODE: 'ES8620',
    NAME: 'Abanca Servicios Financieros E.F.C., S.A.',
    ADDRESS: 'Cl Rúa Nueva, 30, 15004, A Coruña',
    SUPERVISOR_CODE: '8620',
    LENDER_NAME: null,
    LOGO: null,
  },
  {
    EUROPEAN_CODE: 'ES1535',
    NAME: 'AKF Bank GmbH & Co Kg, Sucursal en España',
    ADDRESS: 'AV DE EUROPA, 12, 28108, ALCOBENDAS',
    SUPERVISOR_CODE: '1535',
    LENDER_NAME: null,
    LOGO: null,
  },
  {
    EUROPEAN_CODE: 'ES0011',
    NAME: 'Allfunds Bank, S.A.',
    ADDRESS: 'Cl Padres Dominicos, 7, 28050, Madrid',
    SUPERVISOR_CODE: '0011',
    LENDER_NAME: null,
    LOGO: null,
  },
  {
    EUROPEAN_CODE: 'ES0200',
    NAME: 'ANDBANK ESPAÑA BANCA PRIVADA, S.A.',
    ADDRESS: 'PS DE LA CASTELLANA, 55, 28046, MADRID',
    SUPERVISOR_CODE: '0200',
    LENDER_NAME: null,
    LOGO: null,
  },
  {
    EUROPEAN_CODE: 'ES0136',
    NAME: 'Aresbank, S.A.',
    ADDRESS: 'Ps de la Castellana, 257, 28046, Madrid',
    SUPERVISOR_CODE: '0136',
    LENDER_NAME: null,
    LOGO: null,
  },
  {
    EUROPEAN_CODE: 'ES3183',
    NAME: 'Arquia Bank, S.A.',
    ADDRESS: 'Cl Barquillo, 6, 28004, Madrid',
    SUPERVISOR_CODE: '3183',
    LENDER_NAME: null,
    LOGO: null,
  },
  {
    EUROPEAN_CODE: 'ES1541',
    NAME: 'Attijariwafa Bank Europe, Sucursal en España',
    ADDRESS: 'Cl Bravo Murillo, 210, 28020, Madrid',
    SUPERVISOR_CODE: '1541',
    LENDER_NAME: null,
    LOGO: null,
  },
  {
    EUROPEAN_CODE: 'ES0061',
    NAME: 'Banca March, S.A.',
    ADDRESS: 'AV DE ALEJANDRO ROSELLÓ, 8, 07002, PALMA',
    SUPERVISOR_CODE: '0061',
    LENDER_NAME: null,
    LOGO: null,
  },
  {
    EUROPEAN_CODE: 'ES1550',
    NAME: 'Banca Popolare Etica Società Cooperativa per Azioni, Sucursal en España',
    ADDRESS: 'Cl Santa María, 9, 48005, Bilbao',
    SUPERVISOR_CODE: '1550',
    LENDER_NAME: null,
    LOGO: null,
  },
  {
    EUROPEAN_CODE: 'ES0078',
    NAME: 'Banca Pueyo, S.A.',
    ADDRESS: 'CL SANTA MARÍA DE GUADALUPE, 2, 06700, VILLANUEVA DE LA SERENA',
    SUPERVISOR_CODE: '0078',
    LENDER_NAME: null,
    LOGO: null,
  },
  {
    EUROPEAN_CODE: 'ES0188',
    NAME: 'Banco Alcalá, S.A.',
    ADDRESS: 'Cl José Ortega y Gasset, 7, 28006, Madrid',
    SUPERVISOR_CODE: '0188',
    LENDER_NAME: null,
    LOGO: null,
  },
  {
    EUROPEAN_CODE: 'ES0182',
    NAME: 'Banco Bilbao Vizcaya Argentaria, S.A.',
    ADDRESS: 'Pz de San Nicolás, 4, 48005, Bilbao',
    SUPERVISOR_CODE: '0182',
    LENDER_NAME: LenderName.BBVA,
    LOGO: null,
  },
  {
    EUROPEAN_CODE: 'ES0234',
    NAME: 'BANCO CAMINOS, S.A.',
    ADDRESS: 'CL ALMAGRO, 8, 28010, MADRID',
    SUPERVISOR_CODE: '0234',
    LENDER_NAME: null,
    LOGO: null,
  },
  {
    EUROPEAN_CODE: 'ES0225',
    NAME: 'Banco Cetelem, S.A.',
    ADDRESS: 'PASEO DE LOS MELANCÓLICOS, 14, 28005, Madrid',
    SUPERVISOR_CODE: '0225',
    LENDER_NAME: null,
    LOGO: null,
  },
  {
    EUROPEAN_CODE: 'ES0198',
    NAME: 'Banco Cooperativo Español, S.A.',
    ADDRESS: 'Cl Virgen de los Peligros, 4, 28013, Madrid',
    SUPERVISOR_CODE: '0198',
    LENDER_NAME: null,
    LOGO: null,
  },
  {
    EUROPEAN_CODE: 'ES0091',
    NAME: 'Banco de Albacete, S.A.',
    ADDRESS: 'AV DE CANTABRIA, SN, 28660, BOADILLA DEL MONTE',
    SUPERVISOR_CODE: '0091',
    LENDER_NAME: null,
    LOGO: null,
  },
  {
    EUROPEAN_CODE: 'ES0240',
    NAME: 'Banco de Crédito Social Cooperativo',
    ADDRESS: 'Pº Castellana, 87, 28046, Madrid',
    SUPERVISOR_CODE: '0240',
    LENDER_NAME: null,
    LOGO: null,
  },
  {
    EUROPEAN_CODE: 'ES0003',
    NAME: 'Banco de Depósitos, S.A.',
    ADDRESS: 'Cl José Ortega y Gasset, 29, 28006, Madrid',
    SUPERVISOR_CODE: '0003',
    LENDER_NAME: null,
    LOGO: null,
  },
  {
    EUROPEAN_CODE: 'ES9000',
    NAME: 'BANCO DE ESPAÑA',
    ADDRESS: 'Cl Alcalá, 50, 28014, Madrid',
    SUPERVISOR_CODE: '9000',
    LENDER_NAME: null,
    LOGO: null,
  },
  {
    EUROPEAN_CODE: 'ES1569',
    NAME: 'Banco de Investimento Global SA, Sucursal en España',
    ADDRESS: 'CL SERRANO 67, 28006, MADRID',
    SUPERVISOR_CODE: '1569',
    LENDER_NAME: null,
    LOGO: null,
  },
  {
    EUROPEAN_CODE: 'ES0169',
    NAME: 'Banco de la Nación Argentina, Sucursal en España',
    ADDRESS: 'Cl Núñez de Balboa, 73, 28001, Madrid',
    SUPERVISOR_CODE: '0169',
    LENDER_NAME: null,
    LOGO: null,
  },
  {
    EUROPEAN_CODE: 'ES0081',
    NAME: 'Banco de Sabadell, S.A.',
    ADDRESS: 'Av. Óscar Esplá, 30, 03007, Alicante',
    SUPERVISOR_CODE: '0081',
    LENDER_NAME: LenderName.BS,
    LOGO: null,
  },
  {
    EUROPEAN_CODE: 'ES0184',
    NAME: 'Banco Europeo de Finanzas, S.A.',
    ADDRESS: 'Cl Bolsa, 4, 29015, Málaga',
    SUPERVISOR_CODE: '0184',
    LENDER_NAME: null,
    LOGO: null,
  },
  {
    EUROPEAN_CODE: 'ES0220',
    NAME: 'BANCO FINANTIA, S.A., SUCURSAL EN ESPAÑA',
    ADDRESS: 'AV MENÉNDEZ PELAYO, 67, 28009, MADRID',
    SUPERVISOR_CODE: '0220',
    LENDER_NAME: null,
    LOGO: null,
  },
  {
    EUROPEAN_CODE: 'ES0232',
    NAME: 'Banco Inversis, S.A.',
    ADDRESS: 'Av de la Hispanidad, 6, 28042, Madrid',
    SUPERVISOR_CODE: '0232',
    LENDER_NAME: null,
    LOGO: null,
  },
  {
    EUROPEAN_CODE: 'ES0186',
    NAME: 'Banco Mediolanum, S.A.',
    ADDRESS: 'Cl Roger de Lauria, 19, 46002, Valencia',
    SUPERVISOR_CODE: '0186',
    LENDER_NAME: null,
    LOGO: null,
  },
  {
    EUROPEAN_CODE: 'ES0121',
    NAME: 'Banco Occidental, S.A.',
    ADDRESS: 'Cl Azul, 4, 28050, Madrid',
    SUPERVISOR_CODE: '0121',
    LENDER_NAME: null,
    LOGO: null,
  },
  {
    EUROPEAN_CODE: 'ES0235',
    NAME: 'Banco Pichincha España, S.A..',
    ADDRESS: 'Cl Lagasca, 4, 28001, Madrid',
    SUPERVISOR_CODE: '0235',
    LENDER_NAME: null,
    LOGO: null,
  },
  {
    EUROPEAN_CODE: 'ES1509',
    NAME: 'Banco Primus, S.A., Sucursal en España',
    ADDRESS: 'Av del Partenón, 10, 28042, Madrid',
    SUPERVISOR_CODE: '1509',
    LENDER_NAME: null,
    LOGO: null,
  },
  {
    EUROPEAN_CODE: 'ES0049',
    NAME: 'Banco Santander, S.A.',
    ADDRESS: 'Ps de Pereda, 9-12, 39004, Santander',
    SUPERVISOR_CODE: '0049',
    LENDER_NAME: null,
    LOGO: null,
  },
  {
    EUROPEAN_CODE: 'ES0125',
    NAME: 'Bancofar, S.A.',
    ADDRESS: 'Cl Almagro, 8, 28010, Madrid',
    SUPERVISOR_CODE: '0125',
    LENDER_NAME: null,
    LOGO: null,
  },
  {
    EUROPEAN_CODE: 'ES8843',
    NAME: 'BANGE CREDIT E.F.C. SA',
    ADDRESS: 'CL SERRANO, 106, 28006, MADRID',
    SUPERVISOR_CODE: '8843',
    LENDER_NAME: null,
    LOGO: null,
  },
  {
    EUROPEAN_CODE: 'ES1574',
    NAME: 'Bank Julius Baer Europe, S.A, Sucursal en España',
    ADDRESS: 'PS DE LA CASTELLANA, 7, 28046, MADRID',
    SUPERVISOR_CODE: '1574',
    LENDER_NAME: null,
    LOGO: null,
  },
  {
    EUROPEAN_CODE: 'ES0219',
    NAME: 'Bank of Africa Europe, S.A.',
    ADDRESS: 'Cl Serrano, 59, 28006, Madrid',
    SUPERVISOR_CODE: '0219',
    LENDER_NAME: null,
    LOGO: null,
  },
  {
    EUROPEAN_CODE: 'ES1485',
    NAME: 'Bank of America Europe DAC, Sucursal en España',
    ADDRESS: 'Cl Marqués de Villamagna, 3, 28020, Madrid',
    SUPERVISOR_CODE: '1485',
    LENDER_NAME: null,
    LOGO: null,
  },
  {
    EUROPEAN_CODE: 'ES8832',
    NAME: 'Bankinter Consumer Finance, E.F.C., S.A.',
    ADDRESS: 'AV DE BRUSELAS, 12, 28108, ALCOBENDAS',
    SUPERVISOR_CODE: '8832',
    LENDER_NAME: null,
    LOGO: null,
  },
  {
    EUROPEAN_CODE: 'ES0128',
    NAME: 'Bankinter, S.A.',
    ADDRESS: 'Ps de la Castellana 29, 28046, Madrid',
    SUPERVISOR_CODE: '0128',
    LENDER_NAME: null,
    LOGO: null,
  },
  {
    EUROPEAN_CODE: 'ES1525',
    NAME: 'Banque Chaabi du Maroc, Sucursal en España',
    ADDRESS: 'Av del Doctor Arce, 35, 28002, Madrid',
    SUPERVISOR_CODE: '1525',
    LENDER_NAME: null,
    LOGO: null,
  },
  {
    EUROPEAN_CODE: 'ES1580',
    NAME: 'BANQUE J. SAFRA SARASIN (LUXEMBOURG) SA, SUCURSAL EN ESPAÑA',
    ADDRESS: 'Pº DE LA CASTELLANA,13, 28046, MADRID',
    SUPERVISOR_CODE: '1580',
    LENDER_NAME: null,
    LOGO: null,
  },
  {
    EUROPEAN_CODE: 'ES8211',
    NAME: 'Bansabadell Financiación    E.F.C., S.A.',
    ADDRESS: 'PZ DE CATALUNYA, 1, 08201, SABADELL',
    SUPERVISOR_CODE: '8211',
    LENDER_NAME: null,
    LOGO: null,
  },
  {
    EUROPEAN_CODE: 'ES0152',
    NAME: 'Barclays Bank Ireland PLC, Sucursal en España',
    ADDRESS: 'Cl José Abascal, 51, 28003, Madrid',
    SUPERVISOR_CODE: '0152',
    LENDER_NAME: null,
    LOGO: null,
  },
  {
    EUROPEAN_CODE: 'ES1554',
    NAME: 'BFF Bank, S.P.A. Sucursal en España',
    ADDRESS: 'Ps DE LA CASTELLANA, 81, 28046, Madrid',
    SUPERVISOR_CODE: '1554',
    LENDER_NAME: null,
    LOGO: null,
  },
  {
    EUROPEAN_CODE: 'ES8235',
    NAME: 'Bilbao Hipotecaria, S.A., E.F.C.',
    ADDRESS: 'PS DEL PUERTO 20, 48990, GETXO',
    SUPERVISOR_CODE: '8235',
    LENDER_NAME: null,
    LOGO: null,
  },
  {
    EUROPEAN_CODE: 'ESA86969607',
    NAME: 'BIP&Drive EDE, S.A',
    ADDRESS: 'CL SERRANO, 45, 28001, MADRID',
    SUPERVISOR_CODE: '6712',
    LENDER_NAME: null,
    LOGO: null,
  },
  {
    EUROPEAN_CODE: 'ES1533',
    NAME: 'BMW Bank GmbH, Sucursal en España',
    ADDRESS: 'Av de Burgos, 118, 28050, Madrid',
    SUPERVISOR_CODE: '1533',
    LENDER_NAME: null,
    LOGO: null,
  },
  {
    EUROPEAN_CODE: 'ES6717',
    NAME: 'Bnext Electronic Issuer, E.D.E. S.L.',
    ADDRESS: 'CL ZURBANO, 71, 28010, MADRID',
    SUPERVISOR_CODE: '6717',
    LENDER_NAME: null,
    LOGO: null,
  },
  {
    EUROPEAN_CODE: 'ES1532',
    NAME: 'BNP Paribas Factor, Sucursal en España',
    ADDRESS: 'Cl Emilio Vargas, 4, 28043, Madrid',
    SUPERVISOR_CODE: '1532',
    LENDER_NAME: null,
    LOGO: null,
  },
  {
    EUROPEAN_CODE: 'ES0167',
    NAME: 'BNP Paribas Fortis, S.A., N.V., Sucursal en España',
    ADDRESS: 'Cl Emilio Vargas, 4, 28043, Madrid',
    SUPERVISOR_CODE: '0167',
    LENDER_NAME: null,
    LOGO: null,
  },
  {
    EUROPEAN_CODE: 'ES1492',
    NAME: 'BNP Paribas Lease Group S.A. Sucursal en España',
    ADDRESS: 'Cl Estrella Denébola, 8, 28045, Madrid',
    SUPERVISOR_CODE: '1492',
    LENDER_NAME: null,
    LOGO: null,
  },
  {
    EUROPEAN_CODE: 'ES0149',
    NAME: 'BNP Paribas S.A., Sucursal en España',
    ADDRESS: 'Cl Emilio Vargas, 4, 28043, Madrid',
    SUPERVISOR_CODE: '0149',
    LENDER_NAME: null,
    LOGO: null,
  },
  {
    EUROPEAN_CODE: 'ES1500',
    NAME: 'BPCE Lease, Sucursal en España',
    ADDRESS: 'Ps Recoletos, 7-9, 28004, Madrid',
    SUPERVISOR_CODE: '1500',
    LENDER_NAME: null,
    LOGO: null,
  },
  {
    EUROPEAN_CODE: 'ES1576',
    NAME: 'Bunq B.V., Sucursal en España',
    ADDRESS: 'CL PRINCIPE DE VERGARA, 112, 28002, MADRID',
    SUPERVISOR_CODE: '1576',
    LENDER_NAME: null,
    LOGO: null,
  },
  {
    EUROPEAN_CODE: 'ES1545',
    NAME: 'CA Indosuez Wealth (Europe), Sucursal en España',
    ADDRESS: 'Pº Castellana, 1, 28046, Madrid',
    SUPERVISOR_CODE: '1545',
    LENDER_NAME: null,
    LOGO: null,
  },
  {
    EUROPEAN_CODE: 'ES0038',
    NAME: 'CACEIS Bank Spain, S.A.',
    ADDRESS: 'PQ.EMPRESARIAL LA FINCA-P.CLUB DEPORTIVO, 28223, POZUELO DE ALARCON',
    SUPERVISOR_CODE: '0038',
    LENDER_NAME: null,
    LOGO: null,
  },
  {
    EUROPEAN_CODE: 'ES1451',
    NAME: 'Caisse Régionale de Crédit Agricole Mutuel Sud-Méditerranée (Ariège et Pyrénées-Orientales)',
    ADDRESS: 'Cl Córcega, 301, 08008, Barcelona',
    SUPERVISOR_CODE: '1451',
    LENDER_NAME: null,
    LOGO: null,
  },
  {
    EUROPEAN_CODE: 'ES1493',
    NAME: 'Caixa Banco de Investimento, S.A. Sucursal en España',
    ADDRESS: 'Cl Caléndula, 93, 28109, Alcobendas',
    SUPERVISOR_CODE: '1493',
    LENDER_NAME: null,
    LOGO: null,
  },
  {
    EUROPEAN_CODE: 'ES3025',
    NAME: 'Caixa de Crédit dels Enginyers- Caja de Crédito de los Ingenieros, S. Coop. de Crédito ',
    ADDRESS: 'Via Laietana, 39, 08003, Barcelona',
    SUPERVISOR_CODE: '3025',
    LENDER_NAME: null,
    LOGO: null,
  },
  {
    EUROPEAN_CODE: 'ES3159',
    NAME: 'Caixa Popular-Caixa Rural, S. Coop. de Crédito V.',
    ADDRESS: 'AV JUAN DE LA CIERVA, 9, 46980, PATERNA',
    SUPERVISOR_CODE: '3159',
    LENDER_NAME: null,
    LOGO: null,
  },
  {
    EUROPEAN_CODE: 'ES3045',
    NAME: 'Caixa Rural Altea, Cooperativa de Crédito Valenciana',
    ADDRESS: 'PLACETA DEL CONVENT, 2, 03590, ALTEA',
    SUPERVISOR_CODE: '3045',
    LENDER_NAME: null,
    LOGO: null,
  },
  {
    EUROPEAN_CODE: 'ES3162',
    NAME: 'Caixa Rural Benicarló, S. Coop. de Credit V.',
    ADDRESS: 'AV JOAN CARLES I, 18, 12580, BENICARLO',
    SUPERVISOR_CODE: '3162',
    LENDER_NAME: null,
    LOGO: null,
  },
  {
    EUROPEAN_CODE: 'ES3117',
    NAME: "Caixa Rural D'Algemesí, S. Coop. V. de Crédit",
    ADDRESS: 'CL SAN JOSÉ DE CALASANZ, 6, 46680, ALGEMESI',
    SUPERVISOR_CODE: '3117',
    LENDER_NAME: null,
    LOGO: null,
  },
  {
    EUROPEAN_CODE: 'ES3105',
    NAME: "Caixa Rural de Callosa d'en Sarrià, Cooperativa de Crédito Valenciana",
    ADDRESS: "AV JAIME I, 1, 03510, CALLOSA D'EN SARRIA",
    SUPERVISOR_CODE: '3105',
    LENDER_NAME: null,
    LOGO: null,
  },
  {
    EUROPEAN_CODE: 'ES3096',
    NAME: "Caixa Rural de L'Alcudia, Sociedad Cooperativa Valenciana de Crédito",
    ADDRESS: "AV VERGE DE L'ORETO 2, 46250, L' ALCUDIA",
    SUPERVISOR_CODE: '3096',
    LENDER_NAME: null,
    LOGO: null,
  },
  {
    EUROPEAN_CODE: 'ES3123',
    NAME: 'Caixa Rural de Turís, Cooperativa de Crédito Valenciana',
    ADDRESS: 'PZ CONSTITUCIÓN, 2, 46389, TURIS',
    SUPERVISOR_CODE: '3123',
    LENDER_NAME: null,
    LOGO: null,
  },
  {
    EUROPEAN_CODE: 'ES3070',
    NAME: 'Caixa Rural Galega, Sociedad Cooperativa de Crédito Limitada Gallega',
    ADDRESS: 'Av de Montero Ríos, 24-26, 27002, Lugo',
    SUPERVISOR_CODE: '3070',
    LENDER_NAME: null,
    LOGO: null,
  },
  {
    EUROPEAN_CODE: 'ES3111',
    NAME: "Caixa Rural La Vall 'San Isidro', Sociedad Cooperativa de Crédito Valenciana",
    ADDRESS: "AV CORAZÓN DE JESÚS, 3, 12600, LA VALL D'UIXO",
    SUPERVISOR_CODE: '3111',
    LENDER_NAME: null,
    LOGO: null,
  },
  {
    EUROPEAN_CODE: 'ES3166',
    NAME: 'Caixa Rural Les Coves de Vinromá, S. Coop. de Crédit V.',
    ADDRESS: 'CL SAN ANTONIO, 27, 12185, LES COVES DE VINROMA',
    SUPERVISOR_CODE: '3166',
    LENDER_NAME: null,
    LOGO: null,
  },
  {
    EUROPEAN_CODE: 'ES3160',
    NAME: 'Caixa Rural Sant Josep de Vilavella, S. Coop. de Crédito V.',
    ADDRESS: 'CL CUEVA SANTA, 11, 12526, VILABELLA',
    SUPERVISOR_CODE: '3160',
    LENDER_NAME: null,
    LOGO: null,
  },
  {
    EUROPEAN_CODE: 'ES3102',
    NAME: "Caixa Rural Sant Vicent Ferrer de La Vall D'Uixó, Coop. de Credit V.",
    ADDRESS: "PZ DEL CENTRO, 4, 12600, LA VALL D'UIXO",
    SUPERVISOR_CODE: '3102',
    LENDER_NAME: null,
    LOGO: null,
  },
  {
    EUROPEAN_CODE: 'ES3118',
    NAME: 'Caixa Rural Torrent Cooperativa de Credit Valenciana',
    ADDRESS: 'AV AL VEDAT, 3, 46900, TORRENT',
    SUPERVISOR_CODE: '3118',
    LENDER_NAME: null,
    LOGO: null,
  },
  {
    EUROPEAN_CODE: 'ES3174',
    NAME: 'Caixa Rural Vinarós, S. Coop. de Credit. V.',
    ADDRESS: 'CL SAN CRISTÓBAL, 19, 12500, VINAROS',
    SUPERVISOR_CODE: '3174',
    LENDER_NAME: null,
    LOGO: null,
  },
  {
    EUROPEAN_CODE: 'ESV63050835',
    NAME: 'CAIXABANK MONETARIO RENDIMIENTO, FI',
    ADDRESS: 'Pº de la Castellana, 51 - 5ª Planta, 28046, MADRID',
    SUPERVISOR_CODE: 'FI2680',
    LENDER_NAME: null,
    LOGO: null,
  },
  {
    EUROPEAN_CODE: 'ES8776',
    NAME: 'Caixabank Payments & Consumer, E.F.C., E.P., S.A.',
    ADDRESS: 'Cl Caleruega, 102, 28033, Madrid',
    SUPERVISOR_CODE: '8776',
    LENDER_NAME: null,
    LOGO: null,
  },
  {
    EUROPEAN_CODE: 'ES2100',
    NAME: 'Caixabank, S.A.',
    ADDRESS: 'Cl Pintor Sorolla 2-4, 46002, Valencia',
    SUPERVISOR_CODE: '2100',
    LENDER_NAME: LenderName.CAIXABANK,
    LOGO: 'https://cdn.nemuru.com/assets/logos/caixabank-borrower.svg',
  },
  {
    EUROPEAN_CODE: 'ES2045',
    NAME: 'Caja de Ahorros y Monte de Piedad de Ontinyent',
    ADDRESS: 'PZ SANTO DOMINGO, 24, 46870, ONTINYENT',
    SUPERVISOR_CODE: '2045',
    LENDER_NAME: null,
    LOGO: null,
  },
  {
    EUROPEAN_CODE: 'ES3029',
    NAME: 'Caja de Crédito de Petrel, Caja Rural, Cooperativa de Crédito Valenciana',
    ADDRESS: 'CL SAN BARTOLOMÉ,2, 03610, PETRER',
    SUPERVISOR_CODE: '3029',
    LENDER_NAME: null,
    LOGO: null,
  },
  {
    EUROPEAN_CODE: 'ES3035',
    NAME: 'Caja Laboral Popular Coop. de Crédito',
    ADDRESS: 'PS JOSE MARÍA ARIZMENDIARRIETA SN, 20500, ARRASATE/MONDRAGON',
    SUPERVISOR_CODE: '3035',
    LENDER_NAME: null,
    LOGO: null,
  },
  {
    EUROPEAN_CODE: 'ES3115',
    NAME: "Caja Rural 'Nuestra Madre del Sol', S. Coop. Andaluza de Crédito",
    ADDRESS: 'CL ALTO GUADALQUIVIR, 4, 14430, ADAMUZ',
    SUPERVISOR_CODE: '3115',
    LENDER_NAME: null,
    LOGO: null,
  },
  {
    EUROPEAN_CODE: 'ES3110',
    NAME: 'Caja Rural Católico Agraria, S. Coop. de Crédito V.',
    ADDRESS: 'PZ MAYOR, 10, 12540, VILA-REAL',
    SUPERVISOR_CODE: '3110',
    LENDER_NAME: null,
    LOGO: null,
  },
  {
    EUROPEAN_CODE: 'ES3005',
    NAME: 'Caja Rural Central, Sociedad Cooperativa de Crédito',
    ADDRESS: 'CL JOSÉ MARÍA SARGET 29, 03300, ORIHUELA',
    SUPERVISOR_CODE: '3005',
    LENDER_NAME: null,
    LOGO: null,
  },
  {
    EUROPEAN_CODE: 'ES3190',
    NAME: 'Caja Rural de Albacete, Ciudad Real y Cuenca, Sociedad Cooperativa de Crédito',
    ADDRESS: 'Cl Tesifonte Gallego, 18, 02002, Albacete',
    SUPERVISOR_CODE: '3190',
    LENDER_NAME: null,
    LOGO: null,
  },
  {
    EUROPEAN_CODE: 'ES3150',
    NAME: 'Caja Rural de Albal, Coop. de Crédito V.',
    ADDRESS: 'PZ DEL JARDÍ, 24, 46470, ALBAL',
    SUPERVISOR_CODE: '3150',
    LENDER_NAME: null,
    LOGO: null,
  },
  {
    EUROPEAN_CODE: 'ES3179',
    NAME: 'Caja Rural de Alginet, Sociedad Cooperativa Crédito Valenciana',
    ADDRESS: 'CL VALENCIA 13, 46230, ALGINET',
    SUPERVISOR_CODE: '3179',
    LENDER_NAME: null,
    LOGO: null,
  },
  {
    EUROPEAN_CODE: 'ES3001',
    NAME: 'Caja Rural de Almendralejo, Sociedad Cooperativa de Crédito',
    ADDRESS: 'PZ DE SAN ANTONIO, SN, 06200, ALMENDRALEJO',
    SUPERVISOR_CODE: '3001',
    LENDER_NAME: null,
    LOGO: null,
  },
  {
    EUROPEAN_CODE: 'ES3191',
    NAME: 'Caja Rural de Aragón, Sociedad Cooperativa de Crédito',
    ADDRESS: 'CI Coso 29, 50003, Zaragoza',
    SUPERVISOR_CODE: '3191',
    LENDER_NAME: null,
    LOGO: null,
  },
  {
    EUROPEAN_CODE: 'ES3059',
    NAME: 'Caja Rural de Asturias, Sociedad Cooperativa de Crédito',
    ADDRESS: 'Cl Melquiades Álvarez,7, 33002, Oviedo',
    SUPERVISOR_CODE: '3059',
    LENDER_NAME: null,
    LOGO: null,
  },
  {
    EUROPEAN_CODE: 'ES3089',
    NAME: 'Caja Rural de Baena Ntra. Sra. de Guadalupe Sociedad Cooperativa de Crédito Andaluza',
    ADDRESS: 'CL    DUQUE DE RIVAS, 3, 14850, BAENA',
    SUPERVISOR_CODE: '3089',
    LENDER_NAME: null,
    LOGO: null,
  },
  {
    EUROPEAN_CODE: 'ES3060',
    NAME: 'Caja Rural de Burgos, Fuentepelayo, Segovia y Castelldans, Sociedad Cooperativa de Crédito',
    ADDRESS: 'Cl. LosCoches, 2-4, 40002, Segovia',
    SUPERVISOR_CODE: '3060',
    LENDER_NAME: null,
    LOGO: null,
  },
  {
    EUROPEAN_CODE: 'ES3104',
    NAME: 'Caja Rural de Cañete de Las Torres Ntra. Sra. del Campo Sociedad Cooperativa Andaluza de Crédito',
    ADDRESS: 'PZA DE ESPAÑA, 5, 14660, CAÑETE DE LAS TORRES',
    SUPERVISOR_CODE: '3104',
    LENDER_NAME: null,
    LOGO: null,
  },
  {
    EUROPEAN_CODE: 'ES3127',
    NAME: 'Caja Rural de Casas Ibáñez, S. Coop. de Crédito de Castilla-La Mancha',
    ADDRESS: 'CL TERCIA, 49, 02200, CASAS-IBAÑEZ',
    SUPERVISOR_CODE: '3127',
    LENDER_NAME: null,
    LOGO: null,
  },
  {
    EUROPEAN_CODE: 'ES3121',
    NAME: 'Caja Rural de Cheste, Sociedad Cooperativa de Crédito Valenciana',
    ADDRESS: 'PZ DR. CAJAL, 2, 46380, CHESTE',
    SUPERVISOR_CODE: '3121',
    LENDER_NAME: null,
    LOGO: null,
  },
  {
    EUROPEAN_CODE: 'ES3009',
    NAME: 'Caja Rural de Extremadura, Sociedad Cooperativa de Crédito',
    ADDRESS: 'Av de Santa Marina 15, 06005, Badajoz',
    SUPERVISOR_CODE: '3009',
    LENDER_NAME: null,
    LOGO: null,
  },
  {
    EUROPEAN_CODE: 'ES3007',
    NAME: 'Caja Rural de Gijón, Sociedad Cooperativa Asturiana de Crédito',
    ADDRESS: 'PS DE LA INFANCIA, 10, 33207, GIJON',
    SUPERVISOR_CODE: '3007',
    LENDER_NAME: null,
    LOGO: null,
  },
  {
    EUROPEAN_CODE: 'ES3023',
    NAME: 'Caja Rural de Granada, Sociedad Cooperativa de Crédito',
    ADDRESS: 'Av Don Bosco, 2, 18006, Granada',
    SUPERVISOR_CODE: '3023',
    LENDER_NAME: null,
    LOGO: null,
  },
  {
    EUROPEAN_CODE: 'ES3140',
    NAME: 'Caja Rural de Guissona, Sociedad Cooperativa de Crédito',
    ADDRESS: 'CL TRASPALAU, 8, 25210, GUISSONA',
    SUPERVISOR_CODE: '3140',
    LENDER_NAME: null,
    LOGO: null,
  },
  {
    EUROPEAN_CODE: 'ES3067',
    NAME: 'Caja Rural de Jaén, Barcelona y Madrid, Sociedad Cooperativa de Crédito',
    ADDRESS: 'CL EL CONDADO, 23, 23620, MENGIBAR',
    SUPERVISOR_CODE: '3067',
    LENDER_NAME: null,
    LOGO: null,
  },
  {
    EUROPEAN_CODE: 'ES3008',
    NAME: 'Caja Rural de Navarra, S. Coop. de Crédito ',
    ADDRESS: 'PZ DE LOS FUEROS, 1, 31003, PAMPLONA/IRUÑA',
    SUPERVISOR_CODE: '3008',
    LENDER_NAME: null,
    LOGO: null,
  },
  {
    EUROPEAN_CODE: 'ES3098',
    NAME: 'Caja Rural de Nueva Carteya,    Sociedad Cooperativa Andaluza de Crédito',
    ADDRESS: 'AV ANDALUCÍA, 6, 14857, NUEVA CARTEYA',
    SUPERVISOR_CODE: '3098',
    LENDER_NAME: null,
    LOGO: null,
  },
  {
    EUROPEAN_CODE: 'ES3016',
    NAME: 'Caja Rural de Salamanca, Sociedad Cooperativa de Crédito',
    ADDRESS: 'Puerta de Zamora, 2, 37005, Salamanca',
    SUPERVISOR_CODE: '3016',
    LENDER_NAME: null,
    LOGO: null,
  },
  {
    EUROPEAN_CODE: 'ES3017',
    NAME: 'Caja Rural de Soria, Sociedad Cooperativa de Crédito',
    ADDRESS: 'Cl Diputación,1, 42003, Soria',
    SUPERVISOR_CODE: '3017',
    LENDER_NAME: null,
    LOGO: null,
  },
  {
    EUROPEAN_CODE: 'ES3080',
    NAME: 'Caja Rural de Teruel, Sociedad Cooperativa de Crédito',
    ADDRESS: 'Pz Carlos Castel, 14, 44001, Teruel',
    SUPERVISOR_CODE: '3080',
    LENDER_NAME: null,
    LOGO: null,
  },
  {
    EUROPEAN_CODE: 'ES3020',
    NAME: 'Caja Rural de Utrera, Sociedad Cooperativa Andaluza de Crédito',
    ADDRESS: 'PZ DEL ALTOZANO, 22, 41710, UTRERA',
    SUPERVISOR_CODE: '3020',
    LENDER_NAME: null,
    LOGO: null,
  },
  {
    EUROPEAN_CODE: 'ES3144',
    NAME: 'Caja Rural de Villamalea, S. Coop. de Crédito Agrario de Castilla-La Mancha',
    ADDRESS: 'PZ DE LA CONCEPCIÓN, 1, 02270, VILLAMALEA',
    SUPERVISOR_CODE: '3144',
    LENDER_NAME: null,
    LOGO: null,
  },
  {
    EUROPEAN_CODE: 'ES3152',
    NAME: 'Caja Rural de Villar, Coop. de Crédito V.',
    ADDRESS: 'CL LAS CRUCES 33, 46170, VILLAR DEL ARZOBISPO',
    SUPERVISOR_CODE: '3152',
    LENDER_NAME: null,
    LOGO: null,
  },
  {
    EUROPEAN_CODE: 'ES3085',
    NAME: 'Caja Rural de Zamora, Cooperativa de Crédito',
    ADDRESS: 'Av Alfonso IX, 7, 49014, Zamora',
    SUPERVISOR_CODE: '3085',
    LENDER_NAME: null,
    LOGO: null,
  },
  {
    EUROPEAN_CODE: 'ES3187',
    NAME: 'Caja Rural del Sur, S. Coop. de Crédito',
    ADDRESS: 'Cl Murillo 2, 41001, Sevilla',
    SUPERVISOR_CODE: '3187',
    LENDER_NAME: null,
    LOGO: null,
  },
  {
    EUROPEAN_CODE: 'ES3157',
    NAME: 'Caja Rural La Junquera de Chilches, S. Coop. de Crédito V.',
    ADDRESS: 'PZ DE ESPAÑA, 8, 12592, CHILCHES/XILXES',
    SUPERVISOR_CODE: '3157',
    LENDER_NAME: null,
    LOGO: null,
  },
  {
    EUROPEAN_CODE: 'ES3134',
    NAME: 'Caja Rural Nuestra Señora de la Esperanza de Onda, S. Coop. de Crédito V.',
    ADDRESS: 'PZ EL PLÁ, 19, 12200, ONDA',
    SUPERVISOR_CODE: '3134',
    LENDER_NAME: null,
    LOGO: null,
  },
  {
    EUROPEAN_CODE: 'ES3018',
    NAME: 'Caja Rural Regional San Agustín Fuente Álamo Murcia, Sociedad Cooperativa de Crédito',
    ADDRESS: 'Gran Vía, 1, 30320, Fuente Álamo',
    SUPERVISOR_CODE: '3018',
    LENDER_NAME: null,
    LOGO: null,
  },
  {
    EUROPEAN_CODE: 'ES3165',
    NAME: 'Caja Rural San Isidro de Vilafames S. Coop. de Crédito V.',
    ADDRESS: 'AV DE BARCELÓ, 6, 12192, VILAFAMES',
    SUPERVISOR_CODE: '3165',
    LENDER_NAME: null,
    LOGO: null,
  },
  {
    EUROPEAN_CODE: 'ES3119',
    NAME: 'Caja Rural San Jaime de Alquerías Niño Perdido S. Coop. de Crédito V.',
    ADDRESS: 'CL JAIME CHICHARRO 24, 12539, ALQUERIAS DEL NIÑO PERDIDO',
    SUPERVISOR_CODE: '3119',
    LENDER_NAME: null,
    LOGO: null,
  },
  {
    EUROPEAN_CODE: 'ES3113',
    NAME: 'Caja Rural San José de Alcora S. Coop. de Crédito V.',
    ADDRESS: "CL SAN FRANCISCO, 14, 12110, L' ALCORA",
    SUPERVISOR_CODE: '3113',
    LENDER_NAME: null,
    LOGO: null,
  },
  {
    EUROPEAN_CODE: 'ES3130',
    NAME: 'Caja Rural San José de Almassora, S. Coop. de Crédito V.',
    ADDRESS: 'CL TRINIDAD, 20, 12550, ALMAZORA/ALMASSORA',
    SUPERVISOR_CODE: '3130',
    LENDER_NAME: null,
    LOGO: null,
  },
  {
    EUROPEAN_CODE: 'ES3112',
    NAME: 'Caja Rural San José de Burriana, S. Coop. de Crédito V.',
    ADDRESS: 'PZ EL PLA, 1, 12530, BORRIANA/BURRIANA',
    SUPERVISOR_CODE: '3112',
    LENDER_NAME: null,
    LOGO: null,
  },
  {
    EUROPEAN_CODE: 'ES3135',
    NAME: 'Caja Rural San José de Nules S. Coop. de Crédito V.',
    ADDRESS: 'CL MAYOR, 66, 12520, NULES',
    SUPERVISOR_CODE: '3135',
    LENDER_NAME: null,
    LOGO: null,
  },
  {
    EUROPEAN_CODE: 'ES3095',
    NAME: 'Caja Rural San Roque de Almenara S. Coop. de Crédito    V.',
    ADDRESS: 'CL DR. BERENGUER, 4, 12590, ALMENARA',
    SUPERVISOR_CODE: '3095',
    LENDER_NAME: null,
    LOGO: null,
  },
  {
    EUROPEAN_CODE: 'ES3058',
    NAME: 'Cajamar Caja Rural, Sociedad Cooperativa de Crédito',
    ADDRESS: 'Pz Barcelona, 5, 04006, Almería',
    SUPERVISOR_CODE: '3058',
    LENDER_NAME: null,
    LOGO: null,
  },
  {
    EUROPEAN_CODE: 'ES3076',
    NAME: 'Cajasiete, Caja Rural, Sociedad Cooperativa de Crédito',
    ADDRESS: 'Av Manuel Hermoso Rojas, 8, 38003, Santa Cruz de Tenerife',
    SUPERVISOR_CODE: '3076',
    LENDER_NAME: null,
    LOGO: null,
  },
  {
    EUROPEAN_CODE: 'ES0237',
    NAME: 'Cajasur Banco, S.A.',
    ADDRESS: 'AV. GRAN CAPITÁN, 11-13, 14008, CÓRDOBA',
    SUPERVISOR_CODE: '0237',
    LENDER_NAME: null,
    LOGO: null,
  },
  {
    EUROPEAN_CODE: 'ES4706',
    NAME: 'Caterpillar Financial Corporación Financiera, S.A., E.F.C.',
    ADDRESS: 'VÍA DE LAS DOS CASTILLAS, 33, 28224, POZUELO DE ALARCON',
    SUPERVISOR_CODE: '4706',
    LENDER_NAME: null,
    LOGO: null,
  },
  {
    EUROPEAN_CODE: 'ES2000',
    NAME: 'Cecabank, S.A.',
    ADDRESS: 'Cl Alcalá,27, 28014, Madrid',
    SUPERVISOR_CODE: '2000',
    LENDER_NAME: null,
    LOGO: null,
  },
  {
    EUROPEAN_CODE: 'ES1553',
    NAME: 'China Construction Bank (Europe), S.A., Sucursal en España',
    ADDRESS: 'Av. Diagonal, 640, 08017, Barcelona',
    SUPERVISOR_CODE: '1553',
    LENDER_NAME: null,
    LOGO: null,
  },
  {
    EUROPEAN_CODE: 'ES1474',
    NAME: 'Citibank Europe Plc, Sucursal en España',
    ADDRESS: 'Cl Ortega y Gasset 29, 28006, Madrid',
    SUPERVISOR_CODE: '1474',
    LENDER_NAME: null,
    LOGO: null,
  },
  {
    EUROPEAN_CODE: 'ES1499',
    NAME: 'Claas Financial Services, S.A.S., Sucursal en España',
    ADDRESS: 'Cl Estrella Denébola, 8, 28045, Madrid',
    SUPERVISOR_CODE: '1499',
    LENDER_NAME: null,
    LOGO: null,
  },
  {
    EUROPEAN_CODE: 'ES1546',
    NAME: 'CNH Industrial Capital Europe, S.A.S., Sucursal en España',
    ADDRESS: 'Cl Estrella Denébola, 8, 28045, Madrid',
    SUPERVISOR_CODE: '1546',
    LENDER_NAME: null,
    LOGO: null,
  },
  {
    EUROPEAN_CODE: 'ES1514',
    NAME: 'CNH Industrial Financial Services, Sucursal en España',
    ADDRESS: 'AVENIDA DE ARAGÓN, 402, 28022, Madrid',
    SUPERVISOR_CODE: '1514',
    LENDER_NAME: null,
    LOGO: null,
  },
  {
    EUROPEAN_CODE: 'ES1543',
    NAME: 'Cofidis, S.A. Sucursal en España',
    ADDRESS: 'PZ DE LA PAU, SN, 08940, CORNELLA DE LLOBREGAT',
    SUPERVISOR_CODE: '1543',
    LENDER_NAME: null,
    LOGO: null,
  },
  {
    EUROPEAN_CODE: 'ES2056',
    NAME: "Colonya - Caixa D'estalvis de Pollensa",
    ADDRESS: 'PZ MAYOR, 7, 07460, POLLENÇA',
    SUPERVISOR_CODE: '2056',
    LENDER_NAME: null,
    LOGO: null,
  },
  {
    EUROPEAN_CODE: 'ES0159',
    NAME: 'Commerzbank Aktiengesellschaft, Sucursal en España',
    ADDRESS: 'Ps de la Castellana 259, pl 32, 28046, Madrid',
    SUPERVISOR_CODE: '0159',
    LENDER_NAME: null,
    LOGO: null,
  },
  {
    EUROPEAN_CODE: 'ES1459',
    NAME: 'Cooperatieve Rabobank U.A., Sucursal en España',
    ADDRESS: 'Cl Rafael Calvo, 39, 28010, Madrid',
    SUPERVISOR_CODE: '1459',
    LENDER_NAME: null,
    LOGO: null,
  },
  {
    EUROPEAN_CODE: 'ES8221',
    NAME: 'Corporación Hipotecaria Mutual, S.A., E.F.C.',
    ADDRESS: 'PS DE LA CASTELLANA, 189, 28046, MADRID',
    SUPERVISOR_CODE: '8221',
    LENDER_NAME: null,
    LOGO: null,
  },
  {
    EUROPEAN_CODE: 'ESA88147053',
    NAME: 'CREDIT AGRICOLE CONSUMER FINANCE SPAIN, EFC, S.A.',
    ADDRESS: 'AV. MANOTERAS, 44, 28050, MADRID',
    SUPERVISOR_CODE: '8841',
    LENDER_NAME: null,
    LOGO: null,
  },
  {
    EUROPEAN_CODE: 'ES0154',
    NAME: 'Crédit Agricole Corporate and Investment Bank, Sucursal en España',
    ADDRESS: 'Ps de la Castellana , 1, 28046, Madrid',
    SUPERVISOR_CODE: '0154',
    LENDER_NAME: null,
    LOGO: null,
  },
  {
    EUROPEAN_CODE: 'ES1472',
    NAME: 'Crédit Agricole Leasing & Factoring, Sucursal en España',
    ADDRESS: 'Ps de la Castellana, 1, 28046, Madrid',
    SUPERVISOR_CODE: '1472',
    LENDER_NAME: null,
    LOGO: null,
  },
  {
    EUROPEAN_CODE: 'ES1555',
    NAME: 'Crédit Mutuel Leasing, Sucursal en España',
    ADDRESS: 'Cl RAMÍREZ DE ARELLANO, 29, 28043, Madrid',
    SUPERVISOR_CODE: '1555',
    LENDER_NAME: null,
    LOGO: null,
  },
  {
    EUROPEAN_CODE: 'ES1460',
    NAME: 'Crédit Suisse Ag, Sucursal en España',
    ADDRESS: 'Cl Ayala, 42, 28001, Madrid',
    SUPERVISOR_CODE: '1460',
    LENDER_NAME: null,
    LOGO: null,
  },
  {
    EUROPEAN_CODE: 'ESA79192258',
    NAME: 'Credit Suisse Bank (Europe), S.A.',
    ADDRESS: 'CL AYALA, 42 - 3º B, 28001, MADRID',
    SUPERVISOR_CODE: '0243',
    LENDER_NAME: null,
    LOGO: null,
  },
  {
    EUROPEAN_CODE: 'ES6716',
    NAME: 'Currencies Direct Spain, EDE, SL',
    ADDRESS: 'AV DEL MEDITERRANEO 341, 04638, MOJACAR',
    SUPERVISOR_CODE: '6716',
    LENDER_NAME: null,
    LOGO: null,
  },
  {
    EUROPEAN_CODE: 'ES8842',
    NAME: 'DAIMLER TRUCK FINANCIAL SERVICES ESPAÑA E.F.C., S.A.U.',
    ADDRESS: 'AVDA DE BRUSELAS, 30, 28108, ALCOBENDAS',
    SUPERVISOR_CODE: '8842',
    LENDER_NAME: null,
    LOGO: null,
  },
  {
    EUROPEAN_CODE: 'ES1457',
    NAME: 'De Lage Landen International B.V., Sucursal en España',
    ADDRESS: 'CL    JOSE BARDASANO BAOS, 9 , 28016, MADRID',
    SUPERVISOR_CODE: '1457',
    LENDER_NAME: null,
    LOGO: null,
  },
  {
    EUROPEAN_CODE: 'ES1548',
    NAME: 'Dell Bank International Designated Activity Company, Sucursal en España',
    ADDRESS: 'Cl Ribera del Loira, 8, 28042, Madrid',
    SUPERVISOR_CODE: '1548',
    LENDER_NAME: null,
    LOGO: null,
  },
  {
    EUROPEAN_CODE: 'ES0145',
    NAME: 'Deutsche Bank, A.G., Sucursal en España',
    ADDRESS: 'Ps de la Castellana, 18, 28046, Madrid',
    SUPERVISOR_CODE: '0145',
    LENDER_NAME: null,
    LOGO: null,
  },
  {
    EUROPEAN_CODE: 'ES0019',
    NAME: 'Deutsche Bank, Sociedad Anónima Española',
    ADDRESS: 'Ps de la Castellana, 18, 28046, Madrid',
    SUPERVISOR_CODE: '0019',
    LENDER_NAME: null,
    LOGO: null,
  },
  {
    EUROPEAN_CODE: 'ES8826',
    NAME: 'Deutsche Leasing Iberica, E.F.C.,    S.A.',
    ADDRESS: "PZ. EUROPA, 9 Y11, 08908, L' HOSPITALET DE LLOBREGAT",
    SUPERVISOR_CODE: '8826',
    LENDER_NAME: null,
    LOGO: null,
  },
  {
    EUROPEAN_CODE: 'ES1501',
    NAME: 'Deutsche Pfandbriefbank AG, Sucursal en España',
    ADDRESS: 'Cl Montesquinza, 30, 28010, Madrid',
    SUPERVISOR_CODE: '1501',
    LENDER_NAME: null,
    LOGO: null,
  },
  {
    EUROPEAN_CODE: 'ES0211',
    NAME: 'EBN Banco de Negocios, S.A.',
    ADDRESS: 'Ps de Recoletos, 29, 28004, Madrid',
    SUPERVISOR_CODE: '0211',
    LENDER_NAME: null,
    LOGO: null,
  },
  {
    EUROPEAN_CODE: 'ES1473',
    NAME: 'Edmond de Rothschild (Europe), Sucursal en España',
    ADDRESS: 'Ps de la Castellana, 55, 28046, Madrid',
    SUPERVISOR_CODE: '1473',
    LENDER_NAME: null,
    LOGO: null,
  },
  {
    EUROPEAN_CODE: 'ES3081',
    NAME: 'Eurocaja Rural, Sociedad Cooperativa de Crédito',
    ADDRESS: 'Cl Méjico, 2, 45004, Toledo',
    SUPERVISOR_CODE: '3081',
    LENDER_NAME: null,
    LOGO: null,
  },
  {
    EUROPEAN_CODE: 'ES0239',
    NAME: 'Evo Banco S.A.',
    ADDRESS: 'Cl Serrano, 45, 28001, Madrid',
    SUPERVISOR_CODE: '0239',
    LENDER_NAME: null,
    LOGO: null,
  },
  {
    EUROPEAN_CODE: 'ESW0230061D',
    NAME: 'FCA AUTO BANK, SUCURSAL EN ESPAÑA DE FCA BANK, SPA',
    ADDRESS: 'AV. DE LA VEGA, 15, 28108, ALCOBENDAS',
    SUPERVISOR_CODE: '8640',
    LENDER_NAME: null,
    LOGO: null,
  },
  {
    EUROPEAN_CODE: 'ES0218',
    NAME: 'FCE Bank Plc Sucursal en España',
    ADDRESS: 'CL CALÉNDULA, 13, 28109, ALCOBENDAS',
    SUPERVISOR_CODE: '0218',
    LENDER_NAME: null,
    LOGO: null,
  },
  {
    EUROPEAN_CODE: 'ES8308',
    NAME: 'Financiera Carrión, S.A., E.F.C.',
    ADDRESS: 'Ps del Pintor Rosales, 4, 28008, Madrid',
    SUPERVISOR_CODE: '8308',
    LENDER_NAME: null,
    LOGO: null,
  },
  {
    EUROPEAN_CODE: 'ES8805',
    NAME: 'Financiera El Corte Inglés E.F.C., S.A.',
    ADDRESS: 'CL HERMOSILLA, 112, 28009, MADRID',
    SUPERVISOR_CODE: '8805',
    LENDER_NAME: null,
    LOGO: null,
  },
  {
    EUROPEAN_CODE: 'ES8823',
    NAME: 'Financiera española de crédito a distancia, E.F.C., S.A.',
    ADDRESS: 'Av Fuente de la Mora, 4, 28050, Madrid',
    SUPERVISOR_CODE: '8823',
    LENDER_NAME: null,
    LOGO: null,
  },
  {
    EUROPEAN_CODE: 'ES6718',
    NAME: 'FINPAY Entidad de Dineero Electrónico, S.A',
    ADDRESS: 'PS DE LA CASTELLANA, 126, 28046, Madrid',
    SUPERVISOR_CODE: '6718',
    LENDER_NAME: null,
    LOGO: null,
  },
  {
    EUROPEAN_CODE: 'ES8839',
    NAME: 'GCC Consumo, EFC, S.A',
    ADDRESS: 'Ps de los Melancólicos, 14, 28005, Madrid',
    SUPERVISOR_CODE: '8839',
    LENDER_NAME: null,
    LOGO: null,
  },
  {
    EUROPEAN_CODE: 'ES1496',
    NAME: 'Genefim, Sucursal en España',
    ADDRESS: 'Pz Pablo Ruiz Picasso, 1, 28020, Madrid',
    SUPERVISOR_CODE: '1496',
    LENDER_NAME: null,
    LOGO: null,
  },
  {
    EUROPEAN_CODE: 'ES6702',
    NAME: 'Global Payment Moneytopay, EDE, SL',
    ADDRESS: 'AVDA MANOTERAS, 20, 28050, MADRID',
    SUPERVISOR_CODE: '6702',
    LENDER_NAME: null,
    LOGO: null,
  },
  {
    EUROPEAN_CODE: 'ES1564',
    NAME: 'Goldman Sachs Bank Europe SE, Sucursal en España',
    ADDRESS: 'Cl María de Molina, 6, 28006, Madrid',
    SUPERVISOR_CODE: '1564',
    LENDER_NAME: null,
    LOGO: null,
  },
  {
    EUROPEAN_CODE: 'ES1497',
    NAME: 'Haitong Bank, S.A., Sucursal en España',
    ADDRESS: 'Ps de la Castellana, 52, 28046, Madrid',
    SUPERVISOR_CODE: '1497',
    LENDER_NAME: null,
    LOGO: null,
  },
  {
    EUROPEAN_CODE: 'ES1504',
    NAME: 'Honda Bank GmbH, Sucursal en España',
    ADDRESS: 'CL MAR DEL NORD, 1, 08130, SANTA PERPETUA DE MOGODA',
    SUPERVISOR_CODE: '1504',
    LENDER_NAME: null,
    LOGO: null,
  },
  {
    EUROPEAN_CODE: 'ES0162',
    NAME: 'HSBC Continental Europe, Sucursal en España',
    ADDRESS: 'Pz Pablo Ruiz Picasso sn Pl.33. Torre Picasso, 28020, Madrid',
    SUPERVISOR_CODE: '0162',
    LENDER_NAME: null,
    LOGO: null,
  },
  {
    EUROPEAN_CODE: 'ES2085',
    NAME: 'Ibercaja Banco, S.A.',
    ADDRESS: 'Pz D. Basilio Paraíso, 2, 50008, Zaragoza',
    SUPERVISOR_CODE: '2085',
    LENDER_NAME: null,
    LOGO: null,
  },
  {
    EUROPEAN_CODE: 'ES4832',
    NAME: 'Ibercaja Leasing y Financiación, S.A., Establecimiento Financiero de Crédito',
    ADDRESS: 'Ps de la Constitución, 4, 50001, Zaragoza',
    SUPERVISOR_CODE: '4832',
    LENDER_NAME: null,
    LOGO: null,
  },
  {
    EUROPEAN_CODE: 'ES1538',
    NAME: 'Industrial and Commercial Bank of China (Europe) S.A., Sucursal en España',
    ADDRESS: 'Ps de Recoletos, 12, 28001, Madrid',
    SUPERVISOR_CODE: '1538',
    LENDER_NAME: null,
    LOGO: null,
  },
  {
    EUROPEAN_CODE: 'ES1465',
    NAME: 'Ing Bank, N.V. Sucursal en España',
    ADDRESS: 'VÍA DE LOS POBLADOS, 1F Y 1E, 28033, Madrid',
    SUPERVISOR_CODE: '1465',
    LENDER_NAME: null,
    LOGO: null,
  },
  {
    EUROPEAN_CODE: 'ES1000',
    NAME: 'Instituto de Crédito Oficial',
    ADDRESS: 'Ps del Prado, 4, 28014, Madrid',
    SUPERVISOR_CODE: '1000',
    LENDER_NAME: null,
    LOGO: null,
  },
  {
    EUROPEAN_CODE: 'ES1494',
    NAME: 'Intesa Sanpaolo S.p.A., Sucursal en España',
    ADDRESS: 'Pº de Castellana, 31, 28046, Madrid',
    SUPERVISOR_CODE: '1494',
    LENDER_NAME: null,
    LOGO: null,
  },
  {
    EUROPEAN_CODE: 'ES1567',
    NAME: 'J.P. MORGAN SE, SUCURSAL EN ESPAÑA',
    ADDRESS: 'PS DE LA CASTELLANA, 31, 28046, MADRID',
    SUPERVISOR_CODE: '1567',
    LENDER_NAME: null,
    LOGO: null,
  },
  {
    EUROPEAN_CODE: 'ES1482',
    NAME: 'John Deere Bank, S.A., Sucursal en España',
    ADDRESS: 'BL JOHN DEERE, 2, 28984, PARLA',
    SUPERVISOR_CODE: '1482',
    LENDER_NAME: null,
    LOGO: null,
  },
  {
    EUROPEAN_CODE: 'ES0151',
    NAME: 'JPMorgan Chase Bank National Association, Sucursal en España',
    ADDRESS: 'Ps Castellana, 31, 28045, Madrid',
    SUPERVISOR_CODE: '0151',
    LENDER_NAME: null,
    LOGO: null,
  },
  {
    EUROPEAN_CODE: 'ES2095',
    NAME: 'Kutxabank, S.A.',
    ADDRESS: 'CL GRAN VÍA, 30-32, 48009, BILBAO',
    SUPERVISOR_CODE: '2095',
    LENDER_NAME: null,
    LOGO: null,
  },
  {
    EUROPEAN_CODE: 'ES1547',
    NAME: 'Lombard Odier (Europe), S.A., Sucursal en España',
    ADDRESS: 'PS DE LA CASTELLANA, 66 , 28046, MADRID',
    SUPERVISOR_CODE: '1547',
    LENDER_NAME: null,
    LOGO: null,
  },
  {
    EUROPEAN_CODE: 'ES8342',
    NAME: 'Luzaro E.F.C. S.A',
    ADDRESS: 'AV LIBERTAD, 10, 20004, DONOSTIA/SAN SEBASTIAN',
    SUPERVISOR_CODE: '8342',
    LENDER_NAME: null,
    LOGO: null,
  },
  {
    EUROPEAN_CODE: 'ES1520',
    NAME: 'Mediobanca, Sucursal en España',
    ADDRESS: 'Cl Jorge Manrique, 12, 28006, Madrid',
    SUPERVISOR_CODE: '1520',
    LENDER_NAME: null,
    LOGO: null,
  },
  {
    EUROPEAN_CODE: 'ES4799',
    NAME: 'Mercedes-Benz Financial Services España E.F.C., S.A.',
    ADDRESS: 'AV DE BRUSELAS, 30, 28108, ALCOBENDAS',
    SUPERVISOR_CODE: '4799',
    LENDER_NAME: null,
    LOGO: null,
  },
  {
    EUROPEAN_CODE: 'ES1552',
    NAME: 'Mirabaud & Cie (Europe) S.A., Sucursal en España',
    ADDRESS: 'CI Fortuny, 6, 28010, Madrid',
    SUPERVISOR_CODE: '1552',
    LENDER_NAME: null,
    LOGO: null,
  },
  {
    EUROPEAN_CODE: 'ESA06302657',
    NAME: 'MIRALTA FINANCE BANK, S.A.',
    ADDRESS: 'PLAZA MANUEL GOMEZ MORENO, 2, 28020, MADRID',
    SUPERVISOR_CODE: '0244',
    LENDER_NAME: null,
    LOGO: null,
  },
  {
    EUROPEAN_CODE: 'ES1559',
    NAME: 'Mizuho Bank Europe N.V., Sucursal en España',
    ADDRESS: 'Cl Orense, 34, 28020, Madrid',
    SUPERVISOR_CODE: '1559',
    LENDER_NAME: null,
    LOGO: null,
  },
  {
    EUROPEAN_CODE: 'ES6723',
    NAME: 'MODULR FINANCE B.V., SUCURSAL EN ESPAÑA',
    ADDRESS: 'CL GRAN VIA DE LES CORTS CATALANES 583, 08011, BARCELONA',
    SUPERVISOR_CODE: '6723',
    LENDER_NAME: null,
    LOGO: null,
  },
  {
    EUROPEAN_CODE: 'ES6720',
    NAME: 'Moneycorp Technologies Limited, S.E',
    ADDRESS: 'CL NÚÑEZ DE BALBOA 35, 28001, Madrid',
    SUPERVISOR_CODE: '6720',
    LENDER_NAME: null,
    LOGO: null,
  },
  {
    EUROPEAN_CODE: 'ES0160',
    NAME: 'MUFG Bank (Europe) N.V., Sucursal en España',
    ADDRESS: 'Cl José Ortega y Gasset, 29, 28006, Madrid',
    SUPERVISOR_CODE: '0160',
    LENDER_NAME: null,
    LOGO: null,
  },
  {
    EUROPEAN_CODE: 'ESV85567659',
    NAME: 'Mutuafondo Dinero, FI',
    ADDRESS: 'PASEO CASTELLANA 33, 28046, Madrid',
    SUPERVISOR_CODE: 'FI4082',
    LENDER_NAME: null,
    LOGO: null,
  },
  {
    EUROPEAN_CODE: 'ES1544',
    NAME: 'MYINVESTOR BANCO, S.A.',
    ADDRESS: 'Ps de la Castellana, 55, 28046, Madrid',
    SUPERVISOR_CODE: '1544',
    LENDER_NAME: null,
    LOGO: null,
  },
  {
    EUROPEAN_CODE: 'ES1563',
    NAME: 'N26 Bank GmbH, Sucursal en España',
    ADDRESS: 'Cl JOSÉ ABASCAL, 41, 28003, Madrid',
    SUPERVISOR_CODE: '1563',
    LENDER_NAME: null,
    LOGO: null,
  },
  {
    EUROPEAN_CODE: 'ES1479',
    NAME: 'Natixis, S.A., Sucursal en España',
    ADDRESS: 'Cl Serrano, 90, 28004, Madrid',
    SUPERVISOR_CODE: '1479',
    LENDER_NAME: null,
    LOGO: null,
  },
  {
    EUROPEAN_CODE: 'ES0131',
    NAME: 'Novo Banco, S.A., Sucursal en España',
    ADDRESS: 'CL PRÍNCIPE DE VERGARA, 110, 28002, MADRID',
    SUPERVISOR_CODE: '0131',
    LENDER_NAME: null,
    LOGO: null,
  },
  {
    EUROPEAN_CODE: 'ES0133',
    NAME: 'Nuevo Micro Bank, S.A.',
    ADDRESS: 'CI ADUANA, 18, 28013, MADRID',
    SUPERVISOR_CODE: '0133',
    LENDER_NAME: null,
    LOGO: null,
  },
  {
    EUROPEAN_CODE: 'ES1577',
    NAME: 'Oddo BHF SCA, Sucursal en España',
    ADDRESS: 'CL MAJORAL, 17, 28050, MADRID',
    SUPERVISOR_CODE: '1577',
    LENDER_NAME: null,
    LOGO: null,
  },
  {
    EUROPEAN_CODE: 'ES8814',
    NAME: 'Oney Servicios Financieros, E.F.C., S.A.',
    ADDRESS: 'Via de los Poblados, 1, 28033, Madrid',
    SUPERVISOR_CODE: '8814',
    LENDER_NAME: null,
    LOGO: null,
  },
  {
    EUROPEAN_CODE: 'ES1571',
    NAME: 'Opel Bank, S.A., Sucursal en España',
    ADDRESS: 'CL. EDUARDO BARREIROS, 110, 28041, MADRID',
    SUPERVISOR_CODE: '1565',
    LENDER_NAME: null,
    LOGO: null,
  },
  {
    EUROPEAN_CODE: 'ES0073',
    NAME: 'Open Bank, S.A.',
    ADDRESS: 'PLAZA DE SANTA BARBARA, 2, 28004, Madrid',
    SUPERVISOR_CODE: '0073',
    LENDER_NAME: null,
    LOGO: null,
  },
  {
    EUROPEAN_CODE: 'ES1568',
    NAME: 'Orange Bank, S.A., Sucursal en España',
    ADDRESS: 'Ps Club Deportivo, 1, 28223, Madrid',
    SUPERVISOR_CODE: '1568',
    LENDER_NAME: null,
    LOGO: null,
  },
  {
    EUROPEAN_CODE: 'ES6722',
    NAME: 'PAGONXT ONETRADE ESPAÑA,',
    ADDRESS: 'AVDA CANTABRIA S/N, 28660, BOADILLA DEL MONTE',
    SUPERVISOR_CODE: '6722',
    LENDER_NAME: null,
    LOGO: null,
  },
  {
    EUROPEAN_CODE: 'ES6707',
    NAME: 'Pecunia Cards E.D.E. S.L',
    ADDRESS: 'Cl Guzmán el Bueno, 133, 28003, Madrid',
    SUPERVISOR_CODE: '6707',
    LENDER_NAME: null,
    LOGO: null,
  },
  {
    EUROPEAN_CODE: 'ESW0029839H',
    NAME: 'PFS Card Services Ireland Limited, S.E',
    ADDRESS: 'PS DE LA CASTELLANA, 259, 28046, MADRID',
    SUPERVISOR_CODE: '6713',
    LENDER_NAME: null,
    LOGO: null,
  },
  {
    EUROPEAN_CODE: 'ES1488',
    NAME: 'Pictet & Cie (Europe), S.A., Sucursal en España',
    ADDRESS: 'Cl Ortega y Gasset, 29, 28006, Madrid',
    SUPERVISOR_CODE: '1488',
    LENDER_NAME: null,
    LOGO: null,
  },
  {
    EUROPEAN_CODE: 'ES8838',
    NAME: 'PSA Financial Services Spain E.F.C. S.A',
    ADDRESS: 'CL EDUARDO BARREIROS, 110, 28037, MADRID',
    SUPERVISOR_CODE: '8838',
    LENDER_NAME: null,
    LOGO: null,
  },
  {
    EUROPEAN_CODE: 'ES1508',
    NAME: 'RCI Banque, S.A., Sucursal en España',
    ADDRESS: 'AV. DE EUROPA, 1, 28108, ALCOBENDAS',
    SUPERVISOR_CODE: '1508',
    LENDER_NAME: null,
    LOGO: null,
  },
  {
    EUROPEAN_CODE: 'ES0083',
    NAME: 'Renta 4 Banco, S.A.',
    ADDRESS: 'Ps de la Habana, 74, 28036, Madrid',
    SUPERVISOR_CODE: '0083',
    LENDER_NAME: null,
    LOGO: null,
  },
  {
    EUROPEAN_CODE: 'ES3138',
    NAME: 'Ruralnostra, Sociedad Cooperativa de Crédito Valenciana',
    ADDRESS: 'PZ MAYOR, 2, 12549, BETXI',
    SUPERVISOR_CODE: '3138',
    LENDER_NAME: null,
    LOGO: null,
  },
  {
    EUROPEAN_CODE: 'ES0242',
    NAME: 'Sabadell Consumer Finance, S.A.',
    ADDRESS: 'CL SENA, 12 , 08190, SANT CUGAT DEL VALLES',
    SUPERVISOR_CODE: '0242',
    LENDER_NAME: null,
    LOGO: null,
  },
  {
    EUROPEAN_CODE: 'ES0224',
    NAME: 'Santander Consumer Finance, S.A.',
    ADDRESS: 'Av de Cantabria, sn, 28660, Boadilla del Monte',
    SUPERVISOR_CODE: '0224',
    LENDER_NAME: null,
    LOGO: null,
  },
  {
    EUROPEAN_CODE: 'ES8906',
    NAME: 'Santander Factoring y Confirming, S.A., E.F.C.',
    ADDRESS: 'AV CANTABRIA, SN, 28660, BOADILLA DEL MONTE',
    SUPERVISOR_CODE: '8906',
    LENDER_NAME: null,
    LOGO: null,
  },
  {
    EUROPEAN_CODE: 'ES0036',
    NAME: 'Santander Investment, S.A.',
    ADDRESS: 'AV DE CANTABRIA, SN, 28660, BOADILLA DEL MONTE',
    SUPERVISOR_CODE: '0036',
    LENDER_NAME: null,
    LOGO: null,
  },
  {
    EUROPEAN_CODE: 'ES4797',
    NAME: 'Santander Lease, S.A. EFC',
    ADDRESS: 'AV DE CANTABRIA, SN, 28660, BOADILLA DEL MONTE',
    SUPERVISOR_CODE: '4797',
    LENDER_NAME: null,
    LOGO: null,
  },
  {
    EUROPEAN_CODE: 'ES8813',
    NAME: 'Scania Finance Hispania, E.F.C., S.A.',
    ADDRESS: 'CL JACINTO BENAVENTE, 13, 28850, Torrejon de Ardoz',
    SUPERVISOR_CODE: '8813',
    LENDER_NAME: null,
    LOGO: null,
  },
  {
    EUROPEAN_CODE: 'ES6705',
    NAME: 'Sefide, E.D.E. S.L.',
    ADDRESS: 'AVENIDA DE LA CIENCIA, 2, 18006, Granada',
    SUPERVISOR_CODE: '6705',
    LENDER_NAME: null,
    LOGO: null,
  },
  {
    EUROPEAN_CODE: 'ES8795',
    NAME: 'Servicios Financieros Carrefour, E.F.C., S.A.',
    ADDRESS: 'CARRETERA    NACIONAL I, KM. 14,500, 28108, Alcobendas',
    SUPERVISOR_CODE: '8795',
    LENDER_NAME: null,
    LOGO: null,
  },
  {
    EUROPEAN_CODE: 'ES8833',
    NAME: 'SG Equipment Finance Iberia, E.F.C., S.A.',
    ADDRESS: 'CL SERRANO GALVACHE, 56, 28033, Madrid',
    SUPERVISOR_CODE: '8833',
    LENDER_NAME: null,
    LOGO: null,
  },
  {
    EUROPEAN_CODE: 'ES1490',
    NAME: 'Singular Bank, S.A.',
    ADDRESS: 'CALLE GOYA, 11, 28001, Madrid',
    SUPERVISOR_CODE: '1490',
    LENDER_NAME: null,
    LOGO: null,
  },
  {
    EUROPEAN_CODE: 'ES1551',
    NAME: 'SMBC Bank EU AG, Sucursal en España',
    ADDRESS: 'Cl Pedro Teixeira, 8, 28001, Madrid',
    SUPERVISOR_CODE: '1551',
    LENDER_NAME: null,
    LOGO: null,
  },
  {
    EUROPEAN_CODE: 'ES8816',
    NAME: 'Sociedad Conjunta para la Emisión y Gestión de Medios de Pago, E.F.C., S.A',
    ADDRESS: "Cl O'Donell, 12, 28009, Madrid",
    SUPERVISOR_CODE: '8816',
    LENDER_NAME: null,
    LOGO: null,
  },
  {
    EUROPEAN_CODE: 'ES0108',
    NAME: 'Société Genérale, Sucursal en España',
    ADDRESS: 'Pz Pablo Ruiz Picasso, 1, 28020, Madrid',
    SUPERVISOR_CODE: '0108',
    LENDER_NAME: null,
    LOGO: null,
  },
  {
    EUROPEAN_CODE: 'ES1578',
    NAME: 'Solarisbank AG, Sucursal en España',
    ADDRESS: 'PS DE RECOLETOS, 5, 28004, MADRID',
    SUPERVISOR_CODE: '1578',
    LENDER_NAME: null,
    LOGO: null,
  },
  {
    EUROPEAN_CODE: 'ES1572',
    NAME: 'Stifel Europe Bank, A.G, Sucursal en España',
    ADDRESS: 'Cl Pedro Valdivia, 14, 28006, Madrid',
    SUPERVISOR_CODE: '1572',
    LENDER_NAME: null,
    LOGO: null,
  },
  {
    EUROPEAN_CODE: 'ES0216',
    NAME: 'Targobank, S.A.',
    ADDRESS: 'Cl Ramírez de Arellano, 29, 28043, Madrid',
    SUPERVISOR_CODE: '0216',
    LENDER_NAME: null,
    LOGO: null,
  },
  {
    EUROPEAN_CODE: 'ES8836',
    NAME: 'Telefonica Consumer Finance, EFC, S.A.',
    ADDRESS: 'AVDA MANOTERAS, 20, 28050, MADRID',
    SUPERVISOR_CODE: '8836',
    LENDER_NAME: null,
    LOGO: null,
  },
  {
    EUROPEAN_CODE: 'ES1573',
    NAME: 'The Bank of New York Mellon SA/SV, S.E',
    ADDRESS: 'Cl JOSÉ ABASCAL, 45, 28003, Madrid',
    SUPERVISOR_CODE: '1573',
    LENDER_NAME: null,
    LOGO: null,
  },
  {
    EUROPEAN_CODE: 'ES1570',
    NAME: 'The Governor and Company of the Bank of Ireland, Sucursal en España',
    ADDRESS: 'CL ORTEGA Y GASSET, 29, 28006, MADRID',
    SUPERVISOR_CODE: '1570',
    LENDER_NAME: null,
    LOGO: null,
  },
  {
    EUROPEAN_CODE: 'ES1487',
    NAME: 'Toyota Kreditbank GmbH, Sucursal en España',
    ADDRESS: 'AV DE BRUSELAS, 22, 28108, ALCOBENDAS',
    SUPERVISOR_CODE: '1487',
    LENDER_NAME: null,
    LOGO: null,
  },
  {
    EUROPEAN_CODE: 'ES4784',
    NAME: 'Transolver Finance, E.F.C., S.A.',
    ADDRESS: 'Av Aragón, 402, 28022, Madrid',
    SUPERVISOR_CODE: '4784',
    LENDER_NAME: null,
    LOGO: null,
  },
  {
    EUROPEAN_CODE: 'ES6721',
    NAME: 'TREEZOR S.A.S., SUCURSAL EN ESPAÑA',
    ADDRESS: 'PS DE LA CASTELLANA, 43, 28046, MADRID',
    SUPERVISOR_CODE: '6721',
    LENDER_NAME: null,
    LOGO: null,
  },
  {
    EUROPEAN_CODE: 'ES1491',
    NAME: 'Triodos Bank, N.V., S.E.',
    ADDRESS: 'CL JOSÉ ECHEGARAY, 5, 28230, LAS ROZAS DE MADRID',
    SUPERVISOR_CODE: '1491',
    LENDER_NAME: null,
    LOGO: null,
  },
  {
    EUROPEAN_CODE: 'ES0226',
    NAME: 'UBS Europe SE, Sucursal en España',
    ADDRESS: 'Cl María de Molina, 4, 28006, Madrid',
    SUPERVISOR_CODE: '0226',
    LENDER_NAME: null,
    LOGO: null,
  },
  {
    EUROPEAN_CODE: 'ES2103',
    NAME: 'Unicaja Banco, S.A.',
    ADDRESS: 'Av Andalucía, 10-12, 29007, Málaga',
    SUPERVISOR_CODE: '2103',
    LENDER_NAME: null,
    LOGO: null,
  },
  {
    EUROPEAN_CODE: 'ES1557',
    NAME: 'Unicredit, S.p.A., Sucursal en España',
    ADDRESS: 'Cl Miguel Angel. 11, 28010, Madrid',
    SUPERVISOR_CODE: '1557',
    LENDER_NAME: null,
    LOGO: null,
  },
  {
    EUROPEAN_CODE: 'ES8596',
    NAME: 'Unión Cto. Fin. Mob. e Inm., Credifimo, E.F.C., S.A.',
    ADDRESS: 'Cl Goya, 77, 28001, Madrid',
    SUPERVISOR_CODE: '8596',
    LENDER_NAME: null,
    LOGO: null,
  },
  {
    EUROPEAN_CODE: 'ES8512',
    NAME: 'Unión de Créditos Inmobiliarios, S.A., E.F.C.',
    ADDRESS: 'Cl Retama, 3, 28045, Madrid',
    SUPERVISOR_CODE: '8512',
    LENDER_NAME: null,
    LOGO: null,
  },
  {
    EUROPEAN_CODE: 'ES8769',
    NAME: 'Unión Financiera Asturiana, S.A., E.F.C.',
    ADDRESS: 'CL PELAYO, 15, 33003, OVIEDO',
    SUPERVISOR_CODE: '8769',
    LENDER_NAME: null,
    LOGO: null,
  },
  {
    EUROPEAN_CODE: 'ES6719',
    NAME: 'Unnax Regulatory Services, EDE, SL',
    ADDRESS: "PZ DE EUROPA, 22-24, 08902, L' Hospitalet de Llobregat",
    SUPERVISOR_CODE: '6719',
    LENDER_NAME: null,
    LOGO: null,
  },
  {
    EUROPEAN_CODE: 'ES6709',
    NAME: 'Up Aganea EDE, SA',
    ADDRESS: 'CARRETERA FUENCARRAL A ALCOBENDAS, 14, 28050, Madrid',
    SUPERVISOR_CODE: '6709',
    LENDER_NAME: null,
    LOGO: null,
  },
  {
    EUROPEAN_CODE: 'ES8806',
    NAME: 'VFS Financial Services Spain E.F.C., S.A.',
    ADDRESS: 'CL GOBELAS, 41 Y 45, 28023, MADRID',
    SUPERVISOR_CODE: '8806',
    LENDER_NAME: null,
    LOGO: null,
  },
  {
    EUROPEAN_CODE: 'ES6715',
    NAME: 'Viva Payment Services, S.A. S.E.',
    ADDRESS: 'CL ORENSE, 8, 28020, MADRID',
    SUPERVISOR_CODE: '6715',
    LENDER_NAME: null,
    LOGO: null,
  },
  {
    EUROPEAN_CODE: 'ES1480',
    NAME: 'Volkswagen Bank GmbH, Sucursal en España',
    ADDRESS: 'AV. DE BRUSELAS, 34, 28108, ALCOBENDAS',
    SUPERVISOR_CODE: '1480',
    LENDER_NAME: null,
    LOGO: null,
  },
  {
    EUROPEAN_CODE: 'ES1575',
    NAME: 'Western Union International Bank GMBH, Sucursal en España',
    ADDRESS: 'CL BEATRIZ DE BOBADILLA, 14, 28040, MADRID',
    SUPERVISOR_CODE: '1575',
    LENDER_NAME: null,
    LOGO: null,
  },
  {
    EUROPEAN_CODE: 'ES0229',
    NAME: 'Wizink Bank, S.A.',
    ADDRESS: 'Cl Ulises, 16-18, 28043, Madrid',
    SUPERVISOR_CODE: '0229',
    LENDER_NAME: null,
    LOGO: null,
  },
  {
    EUROPEAN_CODE: 'ES8840',
    NAME: 'Xfera Consumer Finance, E.F.C. S.A.',
    ADDRESS: 'PS DE LOS MELANCOLICOS, 14, 28005, MADRID',
    SUPERVISOR_CODE: '8840',
    LENDER_NAME: null,
    LOGO: null,
  },
  {
    EUROPEAN_CODE: 'ES1560',
    NAME: 'Younited, Sucursal en España',
    ADDRESS: 'Carrer de la Caravel, 12, 08017, Barcelona',
    SUPERVISOR_CODE: '1560',
    LENDER_NAME: null,
    LOGO: null,
  },
];
